import { REACT_QUERY_KEYS } from '@/constants'

import {
  type FetchMonthlyTourReportQuery,
  type FetchMonthlyTourReportDailyReportDetailsQuery
} from './api'

export const monthlyTourReportsQueryKeys = {
  all: [REACT_QUERY_KEYS.MONTHLY_TOUR_REPORTS] as const,
  detail: (query: FetchMonthlyTourReportQuery) => [
    ...monthlyTourReportsQueryKeys.all,
    'detail',
    query
  ],
  dailyReportDetailList: (
    query: FetchMonthlyTourReportDailyReportDetailsQuery
  ) =>
    [
      ...monthlyTourReportsQueryKeys.all,
      'dailyReportDetailList',
      query
    ] as const
}
